import(/* webpackMode: "eager" */ "/home/oreetiene/public_html/app/(otherPages)/termeni-si-conditii/page.jsx");
